import React, { useState } from "react";

import { Provider as LocalizedNamespaceProvider } from "../../contexts/localized-namespace";

export const withLocalizedNamespaceContextProvider =
    <P extends Record<string, unknown>>(Component: React.ComponentType<P>) =>
    (props: P) => (
        <LocalizedNamespaceProvider value={useState<string | undefined>()}>
            <Component {...props} />
        </LocalizedNamespaceProvider>
    );
